var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 8.49992C11.3335 10.3406 9.8415 11.8333 8.00016 11.8333M11.3335 8.49992C11.3335 6.65925 9.8415 5.16659 8.00016 5.16659M11.3335 8.49992H14.6668M8.00016 11.8333C6.15883 11.8333 4.66683 10.3406 4.66683 8.49992M8.00016 11.8333V15.1666M4.66683 8.49992C4.66683 6.65925 6.15883 5.16659 8.00016 5.16659M4.66683 8.49992H1.3335M8.00016 5.16659V1.83325M8.66683 8.49992C8.66683 8.86792 8.36883 9.16659 8.00016 9.16659C7.6315 9.16659 7.3335 8.86792 7.3335 8.49992C7.3335 8.13192 7.6315 7.83325 8.00016 7.83325C8.36883 7.83325 8.66683 8.13192 8.66683 8.49992Z",
    stroke: "#76848F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.2691b874dec9f66fdbfb8d554d3857bc.svg";
export { ForwardRef as ReactComponent };